import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useIsClubSellingStandardPackages_club$key } from "./__generated__/useIsClubSellingStandardPackages_club.graphql";

export const useIsClubSellingStandardPackages = (
  clubRef?: useIsClubSellingStandardPackages_club$key | null
) => {
  const club = useFragment(
    useIsClubSellingStandardPackagesFragmentString,
    clubRef
  );

  return (club?.standardPackages?.count ?? 0) > 0;
};

const useIsClubSellingStandardPackagesFragmentString = graphql`
  fragment useIsClubSellingStandardPackages_club on Club {
    standardPackages: packages(
      packageType: STANDARD
      saleAvailability: PUBLIC
    ) {
      count
    }
  }
`;
